export function getChartDarkDataQuery(props) {
    let q = `SELECT dateString date, 
    value val, 
    spy from marketflow.darkpoolmarket 
    order by dateString 
    limit 100000`
    return q
}